import { IFormInputControl, tg } from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../../../infrastructure/providers/abstract/IApiProvider';
import trimControlValue from '../../../helpers/trimControlValue';
import { isPredefinedForm } from '../../../typeguards';
import { ControlWithValue } from '../../../view-model/FormControlViewModel';
import { FormSource } from '../../../view-model/FormSource';

export const getValueFromArgsOrConfig = <
  T extends ControlWithValue['value'] = string,
>(
  item: IFormInputControl,
  args: TActionArgsValues,
  source: FormSource,
  defaultVal: T
): T => {
  let value;

  if (tg.isSomething(args[item.name])) {
    if (args[item.name].value) {
      value = args[item.name].value;
    } else if (args[item.name].fromState) {
      value = args[item.name].fromState;
    } else {
      value = args[item.name];
    }
  } else {
    value = defaultVal;
  }

  if (
    !isPredefinedForm(source) &&
    source.editMode !== 'edit' &&
    source.editMode !== 'dub' &&
    item.storeValue &&
    source.formConfig[item.name] &&
    tg.isSomething(source.formConfig[item.name].value)
  ) {
    value = source.formConfig[item.name].value as string;
    if (value && item.control === 'DateInput') {
      value = new Date(value);
    }
    args[item.name] = value;
  }

  if ('trim' in item && item.trim && typeof value === 'string') {
    value = trimControlValue(item.trim, value);
  }

  return value;
};
